/**
 * Configuração de API
 *
 * Produção: string vazia — o mesmo processo Express serve o front e a API,
 * então as chamadas são relativas e vão para a origem da página. Sem isso o
 * build apontaria para localhost:3001 no navegador do usuário e toda
 * requisição falharia com "Failed to fetch".
 *
 * Desenvolvimento: localhost:3001, onde o backend roda separado do
 * react-scripts (porta 3000).
 *
 * REACT_APP_API_URL continua tendo prioridade, para o caso de o front ser
 * hospedado à parte da API algum dia.
 */

const API_URL =
  process.env.REACT_APP_API_URL ??
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

export default API_URL;

// Endpoints disponíveis
export const API_ENDPOINTS = {
  UPLOAD_DRE: `${API_URL}/api/upload/dre`,
  UPLOAD_BALANCO: `${API_URL}/api/upload/balanco`,
  GENERATE_DASHBOARD: `${API_URL}/api/upload/generate-dashboard`,
  UPLOAD_SAVE: `${API_URL}/api/upload/save`,
  /** Round-trip: baixar como planilha o que já foi lançado. */
  UPLOAD_PLANILHA: `${API_URL}/api/upload/planilha`,
  /** A planilha modelo em branco, por perfil de empresa. */
  UPLOAD_MODELO: `${API_URL}/api/upload/modelo`,
  /** Porta única: identifica modelo, DRE, balanço ou planilha externa. */
  UPLOAD_IDENTIFICAR: `${API_URL}/api/upload/identificar`,
  /** A planilha que o cliente JA TEM: devolve proposta, nao grava. */
  UPLOAD_RECONHECER: `${API_URL}/api/upload/reconhecer`,
  UPLOAD_RECONHECER_APLICAR: `${API_URL}/api/upload/reconhecer/aplicar`,
  INSIGHTS_CONFIG: `${API_URL}/api/insights/config`,
  INSIGHTS_STATUS: `${API_URL}/api/insights/status`,
  INSIGHTS_COMPANY_PROVIDERS: `${API_URL}/api/insights/providers/companies`,
  CONFIG: `${API_URL}/api/config`,
  CONFIG_RESET: `${API_URL}/api/config/reset`,
  HEALTH: `${API_URL}/health`,
  AUTH_REGISTER: `${API_URL}/api/auth/register`,
  AUTH_LOGIN: `${API_URL}/api/auth/login`,
  AUTH_SESSION: `${API_URL}/api/auth/session`,
  AUTH_LOGOUT: `${API_URL}/api/auth/logout`,
  // Competências: fechar o mês, corrigir o mês, consentimento de IA.
  PERIODOS: `${API_URL}/api/periodos`,
  PERIODOS_PREVIEW: `${API_URL}/api/periodos/preview`,
  PERIODOS_PROJECAO: `${API_URL}/api/periodos/projecao`,
  PERIODOS_CONSENTIMENTO: `${API_URL}/api/periodos/consentimento`,
  /**
   * O plano de ação com estado: marcar como feita, adiar, ver o que venceu.
   * Determinístico e do tier gratuito — nenhuma destas rotas aciona modelo.
   */
  PLANO_DE_ACAO: `${API_URL}/api/plano-de-acao`,
  // Planos: catálogo público e o pedido de assinatura (que NÃO cobra).
  PLANOS: `${API_URL}/api/planos`,
  PLANOS_INTENCAO: `${API_URL}/api/planos/intencao`,
  /** O sinal mais crítico, sem LLM. Ver planoController e insightsService. */
  INSIGHTS_TEASER: `${API_URL}/api/insights/teaser`,
  /**
   * O parecer por IA. Única rota do produto que aciona modelo por pedido do
   * usuário — e a única que faz nascer um parecer. Ver parecerService.js.
   */
  INSIGHTS_PARECER: `${API_URL}/api/insights/parecer`,
};
